import httpClient from "./httpClient";

httpClient.baseUrl = import.meta.env.VITE_API_URL;
httpClient.timeout = 15_000;
